module.exports = __webpack_public_path__ + "static/media/view leave department.81ee4db0.svg";